import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_HOMEWORK: async (context, payload) => {
            await RepositoryFactory.get('homework').get(payload).then((res) => {
                context.commit('SET_HOMEWORK', res.data.homework)
            });
        },

        ADD_HOMEWORK: async (context, payload) => {
            await RepositoryFactory.get('homework').create(payload).then((res) => {
                context.commit('ADD_HOMEWORK', res.data.homework)
            })
        },

        EDIT_HOMEWORK: async (context, payload) => {
            await RepositoryFactory.get('homework').update(payload, payload.id).then((res) => {
                context.commit('SET_HOMEWORK', res.data.homework)
            })
        }
    },

    mutations: {
        SET_HOMEWORK: (state, payload) => {
            state.homework = payload;
        },

        ADD_HOMEWORK: (state, payload) => {
            state.homework.unshift(payload);
        }
    },

    state: {
        homework: []
    },

    getters: {
        HOMEWORK: state => {
            return state.homework;
        }
    }
}